import React, { ReactElement } from "react";
import GlobalSubCategoryList from "../../components/GlobalCategory/SubCategories";
import Layout from "../../components/layout";

const GlobalSubCategoryPage = (): ReactElement => {
  return (
    <Layout>
      <GlobalSubCategoryList />
    </Layout>
  );
};

export default GlobalSubCategoryPage;
